import { Box, Card, Center, Loader, Stack, Text, Title } from '@mantine/core';
import { ActionCallButton } from 'components/ActionCallButton';
import { useClaimCrowdloanRewards } from 'hooks/contracts/rewards/useClaimCrowdloanRewards';
import { useCrowdloanRewards } from 'hooks/queries/useCrowdloanRewards';
import { useAddress } from 'hooks/useAddress';
import { useTranslation } from 'next-i18next';
import { InfoLine } from './InfoLine';

export function Rewards() {
  const { t } = useTranslation('crowdloan-rewards');

  const address = useAddress();
  const rewardsInfo = useCrowdloanRewards(address);
  const { writeContract, isPending } = useClaimCrowdloanRewards();

  const onClaim = () => {
    writeContract();
  };

  return (
    <Card withBorder p={'xl'}>
      <Title order={2} size={'h4'} mb={'lg'}>
        {t('rewardsSummary')}
      </Title>

      <Box h={293}>
        {rewardsInfo?.totalRewards ? (
          <Stack gap={'lg'}>
            <InfoLine
              amount={rewardsInfo.totalRewards}
              label={t('totalRewards')}
            />

            <InfoLine
              amount={rewardsInfo.claimedRewards}
              label={t('claimedRewards')}
            />

            <InfoLine
              amount={rewardsInfo.claimableRewards}
              label={t('claimableRewards')}
            />
            <ActionCallButton
              checkMoonChain={true}
              fullWidth
              loading={isPending}
              onClick={onClaim}
              disabled={rewardsInfo.claimableRewards === 0n || isPending}
            >
              {t('claim')}
            </ActionCallButton>
          </Stack>
        ) : (
          <Center h={'100%'}>
            {rewardsInfo === undefined ? (
              <Loader />
            ) : (
              <Text ta={'center'}>{t('noCrowdloanFound')}</Text>
            )}
          </Center>
        )}
      </Box>
    </Card>
  );
}
